import albums from "./handles/albums";
import artists from "./handles/artists";
import auth from "./handles/auth";
import axios from "axios";
import charts from "./handles/charts";
import directions from "./handles/directions";
import genres from "./handles/genres";
import oauth from "./handles/oauth";
import pages from "./handles/pages";
import personal from "./handles/personal";
import playlists from "./handles/playlists";
import promos from "./handles/promos";
import search from "./handles/search";
import tracks from "./handles/tracks";
import user from "./handles/user";

const axiosMethods = {
  setAuthorizationHeader(value) {
    axios.defaults.headers.common["Authorization"] = value;
  },
  deleteAuthorizationHeader() {
    delete axios.defaults.headers.common["Authorization"];
  },
  async checkAuthorization() {
    try {
      await user.info();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
};

export default {
  albums,
  artists,
  auth,
  charts,
  directions,
  genres,
  oauth,
  pages,
  personal,
  playlists,
  promos,
  search,
  tracks,
  user,
  ...axiosMethods
};
